import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const PaymentMethodSelector = ({ selectedProvider, onProviderChange }) => {
  const { t } = useTranslation('signup');

  return (
    <>
      <h2>{t('choose_payment_method')}</h2>
      <div className="payment-options">
        <div 
          className={`payment-option ${selectedProvider === 'paypal' ? 'selected' : ''}`}
          onClick={() => onProviderChange('paypal')}
        >
          <div className="payment-img">
            <img src="/images/paypal.svg" alt="PayPal" />
          </div>
          <p>{t('paypal', 'PayPal')}</p>
        </div>
        
        <div 
          className={`payment-option ${selectedProvider === 'tap' ? 'selected' : ''}`}
          onClick={() => onProviderChange('tap')}
        >
          <div className="payment-img">
            <img src="/images/cards.svg" alt="Tap" />
          </div>
          <p>{t('cards', 'Cards')}</p>
        </div>
      </div>
    </>
  );
};

PaymentMethodSelector.propTypes = {
  selectedProvider: PropTypes.string.isRequired,
  onProviderChange: PropTypes.func.isRequired,
};

export default PaymentMethodSelector;
